import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';

import { USD } from 'helpers/formatters/number_formats';

export default function PlanTiersTable({ tiers }) {
  function formatToAmount(amount) {
    if (amount == null) {
      return 'Unlimited';
    }

    return USD.format(amount);
  }

  return (
    <Table className="tiers-table">
      <thead>
        <tr>
          <th>Tier</th>
          <th>From</th>
          <th>To</th>
          <th>Percent</th>
        </tr>
      </thead>
      <tbody>
        {tiers.map((tier, key) => (
          <tr key={key}>
            <td>Tier {key + 1}</td>
            <td>{USD.format(tier.from)}</td>
            <td>{formatToAmount(tier.to)}</td>
            <td>{tier.brokerSplit}%</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

PlanTiersTable.propTypes = {
  tiers: PropTypes.arrayOf(PropTypes.shape({

  })),
};
